<template>
  <div>
    <div>
      <img src="../../../assets/menu_first2.png" alt width="100%" style="height:240px">
    </div>
    <div style="padding: 30px 50px; height: 100%;" >
      <el-tabs tab-position="left" style="height: 500px;">
        <el-tab-pane label="法律法规通知公告">
          <div style="height: 100%;">
            <el-row style="text-align: left; ">
              <div style="font-size: 20px;font-weight: bold ;margin: 5px;">法律法规通知公告</div>
            </el-row>
            <el-row>
              <hr size="1" style="COLOR:#ff9999;border-style:double;color:#CCC;margin-top: 20px">
            </el-row>
            <el-row :span="20" style="margin-top: 20px">
              <el-form
                :model="filterForm.data"
                label-width="110px"
                class="search-condition"
                ref="filterRef"
              >
                <el-row :span="20">
                  <el-col :span="12" style="text-align: left">
                    <el-form-item label="公告标题:" prop="title">
                      <el-input placeholder="请输入关键字" v-model.trim="filterForm.data.title"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" style="text-align: right">
                    <el-button type="primary" @click="query">查询</el-button>
                    <el-button type="info" @click="clean">清除筛选</el-button>
                  </el-col>
                </el-row>
              </el-form>
            </el-row>
            <el-row style="margin-top: 20px; padding-left: 20px;">
              <el-table
                :data="table.data"
                stripe
                v-loading="table.loading"
                style="width: 100%;text-align: left"
              >
                <el-table-column type="index" label="序号" width="70"></el-table-column>
                <el-table-column prop="title" label="公告标题"></el-table-column>
                <el-table-column prop="publishDate" label="发布时间"></el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <!--<el-button-->
                    <!--@click="del(table.data, scope.$index)"-->
                    <!--type="text">-->
                    <!--删除-->
                    <!--</el-button>-->
                    <el-button type="text" size="small" @click="showDialog2(scope.row,'show')">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
            <el-row style="margin-top:20px;text-align: right;">
              <el-pagination
                @size-change="pageSizeChange"
                @current-change="pageChange"
                :current-page="table.pagination.currentPage"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="table.pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="table.pagination.total"
              ></el-pagination>
            </el-row>
            <!-- 弹窗-->
            <!-- 弹窗2-->
            <el-dialog
              :title="dialog2.title"
              :visible.sync="dialog2.visible"
              size="small"
              style="text-align: center;"
              @close="closeDialog2()"
            >
              <el-form
                label-width="110px"
                label-position="right"
                ref="refForm"
                :model="dialog2.data"
                :rules="dialog2.rules"
                class="demo-form-inline"
              >
                <el-row>
                  <el-col :span="12" style="width: 100%;">{{dialog2.data.title}}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="12" style="width: 100%;">{{dialog2.data.publishDate}}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="12" style="width: 100%;">{{dialog2.data.contents}}</el-col>
                </el-row>
              </el-form>
            </el-dialog>
          </div>
        </el-tab-pane>
        <el-tab-pane label="项目审查信息">
          <div>
            <el-row style="text-align: left">
              <div style="font-size: 20px;font-weight: bold;margin: 5px;">项目审查信息</div>
            </el-row>
            <el-row>
              <hr size="1" style="COLOR:#ff9999;border-style:double;color:#CCC;margin-top: 20px">
            </el-row>
            <el-row :span="20" style="margin-top: 20px">
              <el-form
                :model="filterForm.data"
                label-width="110px"
                class="search-condition"
                ref="filterRef"
              >
                <el-form-item label="关键字:" style="width:100%" prop="displayProjectName">
                  <el-col :span="12">
                    <el-input
                      placeholder="请输入关键字"
                      v-model.trim="filterForm.data.displayProjectName"
                    ></el-input>
                  </el-col>
                  <el-col :span="12" style="text-align: right">
                    <el-button type="primary" @click="query2">查询</el-button>
                    <el-button type="info" @click="clean">清除筛选</el-button>
                  </el-col>
                </el-form-item>
              </el-form>
            </el-row>
            <el-row style="margin-top: 20px">
              <el-table
                v-loading="this.table2.loading"
                :data="table2.data"
                stripe
                style="width: 100%;text-align: left"
              >
                <el-table-column type="index" align="center" width="70" label="序号"></el-table-column>
                <el-table-column prop="id" label="报审编号" align="center" width="200px"></el-table-column>
                <el-table-column prop="displayProjectName" align="center" label="项目名称"></el-table-column>
                <el-table-column prop="designCorp" align="center" label="勘察设计单位"></el-table-column>
                <el-table-column prop="constructCorp" align="center" label="建设单位"></el-table-column>
                <el-table-column prop="acceptDate" label="接审日期" align="center" width="150px"></el-table-column>
                <el-table-column prop="censorCircsName" label="审查状态" align="center" width="100"></el-table-column>
              </el-table>
            </el-row>
            <el-row style="margin-top:20px;text-align: right;">
              <el-pagination
                @size-change="pageSizeChange"
                @current-change="pageChange"
                :current-page="table2.pagination.currentPage"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="table2.pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="table2.pagination.total"
              ></el-pagination>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      url: {
        notify: "/draw/notify",
        tasks: "/draw/tasks/noticeTask/award"
      },
      table: {
        pagination: {
          currentPage: 1,
          pageSize: 5,
          total: 0
        },
        loading: true,
        data: []
      },
      table2: {
        pagination: {
          currentPage: 1,
          pageSize: 5,
          total: 0
        },
        loading: true,
        data: []
      },
      filterForm: {
        data: {
          title: "",
          displayProjectName: ""
        }
      },
      dialog2: {
        title: "",
        visible: false,
        checkPass: "",
        type: "show",
        data: {
          id: "",
          title: "",
          contents: "",
          toDesign: false,
          toConstruction: false,
          toCheckDrawing: false,
          publishDate: "",
          state: false
        },
        rules: {},
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        loading: true
      }
    };
  },
  mounted() {
    this.query();
    this.query2();
  },
  methods: {
    query() {
      this.table.loading = true;
      let filterList = "";
      /* filterList += "&constructCorp="+this.$store.getters.getStorage.user.user.orgName;*/
      if (this.filterForm.data.title != "") {
        filterList += "&title=" + this.filterForm.data.title;
      }
      this.$http
        .get(
          this.url.notify +
            "?" +
            "currentPage=" +
            this.table.pagination.currentPage +
            "&pageSize=" +
            this.table.pagination.pageSize +
            filterList
        )
        .then(
          res => {
            if (res.body.status === 200) {
              this.table.data = res.data.result.data;
              this.table.pagination.total = res.data.result.total;
              this.table.loading = false;
            } else {
              this.$message.error("查询失败，请联系管理员");
            }
          },
          error => {
            this.$message.error("查询失败，请联系管理员");
          }
        );
    },

    query2() {
      this.table2.loading = true;
      let filterList = "";
      if (this.filterForm.data.displayProjectName != "") {
        filterList += "&keyword=" + this.filterForm.data.displayProjectName;
      }
      this.$http
        .get(
          this.url.tasks +
            "?currentPage=" +
            this.table2.pagination.currentPage +
            "&pageSize=" +
            this.table2.pagination.pageSize +
            filterList
        )
        .then(
          res => {
            if (res.ok) {
              this.table2.data = res.data.result.data;
              this.table2.pagination.total = res.data.result.total;
              this.table2.loading = false;
            } else {
              this.$message.error("查询失败，请联系管理员");
            }
          },
          error => {
            this.$message.error("查询失败，请联系管理员");
          }
        );
    },
    showDialog2(formData, type) {
       
       this.$router.push({path:'/noticeListat', query:{id:formData.id}});
      // this.$router.push('/');
    },
    clean() {
      this.$refs.filterRef.resetFields();
      this.query();
    },
    pageSizeChange(pageSize) {
      //每页数量改变
      this.table.pagination.pageSize = pageSize;
      this.query();
    },
    pageChange(currentPage) {
      //翻页触发
      this.table.pagination.currentPage = currentPage;
      this.query();
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/login/notice/noticeList.vue